import {useValueEffect as $857d64dbfd73d664$re_export$useValueEffect, useResizeObserver as $857d64dbfd73d664$re_export$useResizeObserver, mergeProps as $5lsDl$mergeProps, useLayoutEffect as $5lsDl$useLayoutEffect} from "@react-aria/utils";
import $5lsDl$clsx from "clsx";
import $5lsDl$react, {useState as $5lsDl$useState, useEffect as $5lsDl$useEffect, useRef as $5lsDl$useRef, useImperativeHandle as $5lsDl$useImperativeHandle, useMemo as $5lsDl$useMemo, useContext as $5lsDl$useContext} from "react";
import {useIsSSR as $5lsDl$useIsSSR} from "@react-aria/ssr";
import {useLocale as $5lsDl$useLocale} from "@react-aria/i18n";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
let $fd933927dbac1f15$export$46d604dce8bf8724 = false;
function $fd933927dbac1f15$export$f9d3bfd10703eb31() {
    $fd933927dbac1f15$export$46d604dce8bf8724 = true;
    console.warn("Legacy spectrum-prefixed class names enabled for backward compatibility. We recommend replacing instances of CSS overrides targeting spectrum selectors in your app with custom class names of your own, and disabling this flag.");
}
function $fd933927dbac1f15$export$ce4ab0c55987d1ff(cssModule, ...values) {
    let classes = [];
    for (let value of values){
        if (typeof value === "object" && value) {
            let mapped = {};
            for(let key in value){
                if (cssModule[key]) mapped[cssModule[key]] = value[key];
                if ($fd933927dbac1f15$export$46d604dce8bf8724 || !cssModule[key]) mapped[key] = value[key];
            }
            classes.push(mapped);
        } else if (typeof value === "string") {
            if (cssModule[value]) classes.push(cssModule[value]);
            if ($fd933927dbac1f15$export$46d604dce8bf8724 || !cssModule[value]) classes.push(value);
        } else classes.push(value);
    }
    return (0, $5lsDl$clsx)(...classes);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $bde65b0159e7c06e$export$a5f5a6912b18861c(children) {
    let element;
    if (typeof children === "string") element = /*#__PURE__*/ (0, $5lsDl$react).createElement("span", null, children);
    else element = (0, $5lsDl$react).Children.only(children);
    return element;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

function $3df547e395c4522f$export$32d5543ab307c01(query) {
    let supportsMatchMedia = typeof window !== "undefined" && typeof window.matchMedia === "function";
    let [matches, setMatches] = (0, $5lsDl$useState)(()=>supportsMatchMedia ? window.matchMedia(query).matches : false);
    (0, $5lsDl$useEffect)(()=>{
        if (!supportsMatchMedia) return;
        let mq = window.matchMedia(query);
        let onChange = (evt)=>{
            setMatches(evt.matches);
        };
        mq.addListener(onChange);
        return ()=>{
            mq.removeListener(onChange);
        };
    }, [
        supportsMatchMedia,
        query
    ]);
    // If in SSR, the media query should never match. Once the page hydrates,
    // this will update and the real value will be returned.
    let isSSR = (0, $5lsDl$useIsSSR)();
    return isSSR ? false : matches;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
function $98e5a8ae0e6415af$export$a5795cc979dfae80(ref) {
    return {
        UNSAFE_getDOMNode () {
            return ref.current;
        }
    };
}
function $98e5a8ae0e6415af$export$79d69eee6ae4b329(domRef, focusableRef = domRef) {
    return {
        ...$98e5a8ae0e6415af$export$a5795cc979dfae80(domRef),
        focus () {
            if (focusableRef.current) focusableRef.current.focus();
        }
    };
}
function $98e5a8ae0e6415af$export$c2c55ef9111cafd8(ref) {
    let domRef = (0, $5lsDl$useRef)(null);
    (0, $5lsDl$useImperativeHandle)(ref, ()=>$98e5a8ae0e6415af$export$a5795cc979dfae80(domRef));
    return domRef;
}
function $98e5a8ae0e6415af$export$96a734597687c040(ref, focusableRef) {
    let domRef = (0, $5lsDl$useRef)(null);
    (0, $5lsDl$useImperativeHandle)(ref, ()=>$98e5a8ae0e6415af$export$79d69eee6ae4b329(domRef, focusableRef));
    return domRef;
}
function $98e5a8ae0e6415af$export$c7e28c72a4823176(ref) {
    return {
        get current () {
            return ref.current && ref.current.UNSAFE_getDOMNode();
        }
    };
}
function $98e5a8ae0e6415af$export$1d5cc31d9d8df817(ref) {
    return (0, $5lsDl$useMemo)(()=>$98e5a8ae0e6415af$export$c7e28c72a4823176(ref), [
        ref
    ]);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

const $1051245f87c5981d$var$Context = /*#__PURE__*/ (0, $5lsDl$react).createContext(null);
$1051245f87c5981d$var$Context.displayName = "BreakpointContext";
function $1051245f87c5981d$export$8214320346cf5104(props) {
    let { children: children, matchedBreakpoints: matchedBreakpoints } = props;
    return /*#__PURE__*/ (0, $5lsDl$react).createElement($1051245f87c5981d$var$Context.Provider, {
        value: {
            matchedBreakpoints: matchedBreakpoints
        }
    }, children);
}
function $1051245f87c5981d$export$140ae7baa51cca23(breakpoints) {
    let entries = Object.entries(breakpoints).sort(([, valueA], [, valueB])=>valueB - valueA);
    let breakpointQueries = entries.map(([, value])=>`(min-width: ${value}px)`);
    let supportsMatchMedia = typeof window !== "undefined" && typeof window.matchMedia === "function";
    let getBreakpointHandler = ()=>{
        let matched = [];
        for(let i in breakpointQueries){
            let query = breakpointQueries[i];
            if (window.matchMedia(query).matches) matched.push(entries[i][0]);
        }
        matched.push("base");
        return matched;
    };
    let [breakpoint, setBreakpoint] = (0, $5lsDl$useState)(()=>supportsMatchMedia ? getBreakpointHandler() : [
            "base"
        ]);
    (0, $5lsDl$useEffect)(()=>{
        if (!supportsMatchMedia) return;
        let onResize = ()=>{
            const breakpointHandler = getBreakpointHandler();
            setBreakpoint((previousBreakpointHandler)=>{
                if (previousBreakpointHandler.length !== breakpointHandler.length || previousBreakpointHandler.some((breakpoint, idx)=>breakpoint !== breakpointHandler[idx])) return [
                    ...breakpointHandler
                ]; // Return a new array to force state change
                return previousBreakpointHandler;
            });
        };
        window.addEventListener("resize", onResize);
        return ()=>{
            window.removeEventListener("resize", onResize);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        supportsMatchMedia
    ]);
    // If in SSR, the media query should never match. Once the page hydrates,
    // this will update and the real value will be returned.
    let isSSR = (0, $5lsDl$useIsSSR)();
    return isSSR ? [
        "base"
    ] : breakpoint;
}
function $1051245f87c5981d$export$199d6754bdf4e1e3() {
    return (0, $5lsDl$useContext)($1051245f87c5981d$var$Context);
}



const $380ed8f3903c3931$export$fe9c6e915565b4e8 = {
    margin: [
        "margin",
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    marginStart: [
        $380ed8f3903c3931$var$rtl("marginLeft", "marginRight"),
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    marginEnd: [
        $380ed8f3903c3931$var$rtl("marginRight", "marginLeft"),
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    // marginLeft: ['marginLeft', dimensionValue],
    // marginRight: ['marginRight', dimensionValue],
    marginTop: [
        "marginTop",
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    marginBottom: [
        "marginBottom",
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    marginX: [
        [
            "marginLeft",
            "marginRight"
        ],
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    marginY: [
        [
            "marginTop",
            "marginBottom"
        ],
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    width: [
        "width",
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    height: [
        "height",
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    minWidth: [
        "minWidth",
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    minHeight: [
        "minHeight",
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    maxWidth: [
        "maxWidth",
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    maxHeight: [
        "maxHeight",
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    isHidden: [
        "display",
        $380ed8f3903c3931$var$hiddenValue
    ],
    alignSelf: [
        "alignSelf",
        $380ed8f3903c3931$export$46b6c81d11d2c30a
    ],
    justifySelf: [
        "justifySelf",
        $380ed8f3903c3931$export$46b6c81d11d2c30a
    ],
    position: [
        "position",
        $380ed8f3903c3931$var$anyValue
    ],
    zIndex: [
        "zIndex",
        $380ed8f3903c3931$var$anyValue
    ],
    top: [
        "top",
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    bottom: [
        "bottom",
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    start: [
        $380ed8f3903c3931$var$rtl("left", "right"),
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    end: [
        $380ed8f3903c3931$var$rtl("right", "left"),
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    left: [
        "left",
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    right: [
        "right",
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    order: [
        "order",
        $380ed8f3903c3931$var$anyValue
    ],
    flex: [
        "flex",
        $380ed8f3903c3931$var$flexValue
    ],
    flexGrow: [
        "flexGrow",
        $380ed8f3903c3931$export$46b6c81d11d2c30a
    ],
    flexShrink: [
        "flexShrink",
        $380ed8f3903c3931$export$46b6c81d11d2c30a
    ],
    flexBasis: [
        "flexBasis",
        $380ed8f3903c3931$export$46b6c81d11d2c30a
    ],
    gridArea: [
        "gridArea",
        $380ed8f3903c3931$export$46b6c81d11d2c30a
    ],
    gridColumn: [
        "gridColumn",
        $380ed8f3903c3931$export$46b6c81d11d2c30a
    ],
    gridColumnEnd: [
        "gridColumnEnd",
        $380ed8f3903c3931$export$46b6c81d11d2c30a
    ],
    gridColumnStart: [
        "gridColumnStart",
        $380ed8f3903c3931$export$46b6c81d11d2c30a
    ],
    gridRow: [
        "gridRow",
        $380ed8f3903c3931$export$46b6c81d11d2c30a
    ],
    gridRowEnd: [
        "gridRowEnd",
        $380ed8f3903c3931$export$46b6c81d11d2c30a
    ],
    gridRowStart: [
        "gridRowStart",
        $380ed8f3903c3931$export$46b6c81d11d2c30a
    ]
};
const $380ed8f3903c3931$export$e0705d1a55f297c = {
    ...$380ed8f3903c3931$export$fe9c6e915565b4e8,
    backgroundColor: [
        "backgroundColor",
        $380ed8f3903c3931$var$backgroundColorValue
    ],
    borderWidth: [
        "borderWidth",
        $380ed8f3903c3931$var$borderSizeValue
    ],
    borderStartWidth: [
        $380ed8f3903c3931$var$rtl("borderLeftWidth", "borderRightWidth"),
        $380ed8f3903c3931$var$borderSizeValue
    ],
    borderEndWidth: [
        $380ed8f3903c3931$var$rtl("borderRightWidth", "borderLeftWidth"),
        $380ed8f3903c3931$var$borderSizeValue
    ],
    borderLeftWidth: [
        "borderLeftWidth",
        $380ed8f3903c3931$var$borderSizeValue
    ],
    borderRightWidth: [
        "borderRightWidth",
        $380ed8f3903c3931$var$borderSizeValue
    ],
    borderTopWidth: [
        "borderTopWidth",
        $380ed8f3903c3931$var$borderSizeValue
    ],
    borderBottomWidth: [
        "borderBottomWidth",
        $380ed8f3903c3931$var$borderSizeValue
    ],
    borderXWidth: [
        [
            "borderLeftWidth",
            "borderRightWidth"
        ],
        $380ed8f3903c3931$var$borderSizeValue
    ],
    borderYWidth: [
        [
            "borderTopWidth",
            "borderBottomWidth"
        ],
        $380ed8f3903c3931$var$borderSizeValue
    ],
    borderColor: [
        "borderColor",
        $380ed8f3903c3931$var$borderColorValue
    ],
    borderStartColor: [
        $380ed8f3903c3931$var$rtl("borderLeftColor", "borderRightColor"),
        $380ed8f3903c3931$var$borderColorValue
    ],
    borderEndColor: [
        $380ed8f3903c3931$var$rtl("borderRightColor", "borderLeftColor"),
        $380ed8f3903c3931$var$borderColorValue
    ],
    borderLeftColor: [
        "borderLeftColor",
        $380ed8f3903c3931$var$borderColorValue
    ],
    borderRightColor: [
        "borderRightColor",
        $380ed8f3903c3931$var$borderColorValue
    ],
    borderTopColor: [
        "borderTopColor",
        $380ed8f3903c3931$var$borderColorValue
    ],
    borderBottomColor: [
        "borderBottomColor",
        $380ed8f3903c3931$var$borderColorValue
    ],
    borderXColor: [
        [
            "borderLeftColor",
            "borderRightColor"
        ],
        $380ed8f3903c3931$var$borderColorValue
    ],
    borderYColor: [
        [
            "borderTopColor",
            "borderBottomColor"
        ],
        $380ed8f3903c3931$var$borderColorValue
    ],
    borderRadius: [
        "borderRadius",
        $380ed8f3903c3931$var$borderRadiusValue
    ],
    borderTopStartRadius: [
        $380ed8f3903c3931$var$rtl("borderTopLeftRadius", "borderTopRightRadius"),
        $380ed8f3903c3931$var$borderRadiusValue
    ],
    borderTopEndRadius: [
        $380ed8f3903c3931$var$rtl("borderTopRightRadius", "borderTopLeftRadius"),
        $380ed8f3903c3931$var$borderRadiusValue
    ],
    borderBottomStartRadius: [
        $380ed8f3903c3931$var$rtl("borderBottomLeftRadius", "borderBottomRightRadius"),
        $380ed8f3903c3931$var$borderRadiusValue
    ],
    borderBottomEndRadius: [
        $380ed8f3903c3931$var$rtl("borderBottomRightRadius", "borderBottomLeftRadius"),
        $380ed8f3903c3931$var$borderRadiusValue
    ],
    borderTopLeftRadius: [
        "borderTopLeftRadius",
        $380ed8f3903c3931$var$borderRadiusValue
    ],
    borderTopRightRadius: [
        "borderTopRightRadius",
        $380ed8f3903c3931$var$borderRadiusValue
    ],
    borderBottomLeftRadius: [
        "borderBottomLeftRadius",
        $380ed8f3903c3931$var$borderRadiusValue
    ],
    borderBottomRightRadius: [
        "borderBottomRightRadius",
        $380ed8f3903c3931$var$borderRadiusValue
    ],
    padding: [
        "padding",
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    paddingStart: [
        $380ed8f3903c3931$var$rtl("paddingLeft", "paddingRight"),
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    paddingEnd: [
        $380ed8f3903c3931$var$rtl("paddingRight", "paddingLeft"),
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    paddingLeft: [
        "paddingLeft",
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    paddingRight: [
        "paddingRight",
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    paddingTop: [
        "paddingTop",
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    paddingBottom: [
        "paddingBottom",
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    paddingX: [
        [
            "paddingLeft",
            "paddingRight"
        ],
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    paddingY: [
        [
            "paddingTop",
            "paddingBottom"
        ],
        $380ed8f3903c3931$export$abc24f5b99744ea6
    ],
    overflow: [
        "overflow",
        $380ed8f3903c3931$export$46b6c81d11d2c30a
    ]
};
const $380ed8f3903c3931$var$borderStyleProps = {
    borderWidth: "borderStyle",
    borderLeftWidth: "borderLeftStyle",
    borderRightWidth: "borderRightStyle",
    borderTopWidth: "borderTopStyle",
    borderBottomWidth: "borderBottomStyle"
};
function $380ed8f3903c3931$var$rtl(ltr, rtl) {
    return (direction)=>direction === "rtl" ? rtl : ltr;
}
const $380ed8f3903c3931$var$UNIT_RE = /(%|px|em|rem|vw|vh|auto|cm|mm|in|pt|pc|ex|ch|rem|vmin|vmax|fr)$/;
const $380ed8f3903c3931$var$FUNC_RE = /^\s*\w+\(/;
const $380ed8f3903c3931$var$SPECTRUM_VARIABLE_RE = /(static-)?size-\d+|single-line-(height|width)/g;
function $380ed8f3903c3931$export$abc24f5b99744ea6(value) {
    if (typeof value === "number") return value + "px";
    if ($380ed8f3903c3931$var$UNIT_RE.test(value)) return value;
    if ($380ed8f3903c3931$var$FUNC_RE.test(value)) return value.replace($380ed8f3903c3931$var$SPECTRUM_VARIABLE_RE, "var(--spectrum-global-dimension-$&, var(--spectrum-alias-$&))");
    return `var(--spectrum-global-dimension-${value}, var(--spectrum-alias-${value}))`;
}
function $380ed8f3903c3931$export$f348bec194f2e6b5(value, matchedBreakpoints) {
    value = $380ed8f3903c3931$export$52dbfdbe1b2c3541(value, matchedBreakpoints);
    return $380ed8f3903c3931$export$abc24f5b99744ea6(value);
}
function $380ed8f3903c3931$var$colorValue(value, type = "default", version = 5) {
    if (version > 5) return `var(--spectrum-${value}, var(--spectrum-semantic-${value}-color-${type}))`;
    return `var(--spectrum-legacy-color-${value}, var(--spectrum-global-color-${value}, var(--spectrum-semantic-${value}-color-${type})))`;
}
function $380ed8f3903c3931$var$backgroundColorValue(value, version = 5) {
    return `var(--spectrum-alias-background-color-${value}, ${$380ed8f3903c3931$var$colorValue(value, "background", version)})`;
}
function $380ed8f3903c3931$var$borderColorValue(value, version = 5) {
    if (value === "default") return "var(--spectrum-alias-border-color)";
    return `var(--spectrum-alias-border-color-${value}, ${$380ed8f3903c3931$var$colorValue(value, "border", version)})`;
}
function $380ed8f3903c3931$var$borderSizeValue(value) {
    return value && value !== "none" ? `var(--spectrum-alias-border-size-${value})` : "0";
}
function $380ed8f3903c3931$var$borderRadiusValue(value) {
    return `var(--spectrum-alias-border-radius-${value})`;
}
function $380ed8f3903c3931$var$hiddenValue(value) {
    return value ? "none" : undefined;
}
function $380ed8f3903c3931$var$anyValue(value) {
    return value;
}
function $380ed8f3903c3931$var$flexValue(value) {
    if (typeof value === "boolean") return value ? "1" : undefined;
    return "" + value;
}
function $380ed8f3903c3931$export$f3c39bb9534218d0(props, handlers, direction, matchedBreakpoints) {
    let style = {};
    for(let key in props){
        let styleProp = handlers[key];
        if (!styleProp || props[key] == null) continue;
        let [name, convert] = styleProp;
        if (typeof name === "function") name = name(direction);
        let prop = $380ed8f3903c3931$export$52dbfdbe1b2c3541(props[key], matchedBreakpoints);
        let value = convert(prop, props.colorVersion);
        if (Array.isArray(name)) for (let k of name)style[k] = value;
        else style[name] = value;
    }
    for(let prop in $380ed8f3903c3931$var$borderStyleProps)if (style[prop]) {
        style[$380ed8f3903c3931$var$borderStyleProps[prop]] = "solid";
        style.boxSizing = "border-box";
    }
    return style;
}
function $380ed8f3903c3931$export$b8e6fb9d2dff3f41(props, handlers = $380ed8f3903c3931$export$fe9c6e915565b4e8, options = {}) {
    let { UNSAFE_className: UNSAFE_className, UNSAFE_style: UNSAFE_style, ...otherProps } = props;
    let breakpointProvider = (0, $1051245f87c5981d$export$199d6754bdf4e1e3)();
    let { direction: direction } = (0, $5lsDl$useLocale)();
    let { matchedBreakpoints: matchedBreakpoints = (breakpointProvider === null || breakpointProvider === void 0 ? void 0 : breakpointProvider.matchedBreakpoints) || [
        "base"
    ] } = options;
    let styles = $380ed8f3903c3931$export$f3c39bb9534218d0(props, handlers, direction, matchedBreakpoints);
    let style = {
        ...UNSAFE_style,
        ...styles
    };
    // @ts-ignore
    if (otherProps.className) console.warn("The className prop is unsafe and is unsupported in React Spectrum v3. Please use style props with Spectrum variables, or UNSAFE_className if you absolutely must do something custom. Note that this may break in future versions due to DOM structure changes.");
    // @ts-ignore
    if (otherProps.style) console.warn("The style prop is unsafe and is unsupported in React Spectrum v3. Please use style props with Spectrum variables, or UNSAFE_style if you absolutely must do something custom. Note that this may break in future versions due to DOM structure changes.");
    let styleProps = {
        style: style,
        className: UNSAFE_className
    };
    if ($380ed8f3903c3931$export$52dbfdbe1b2c3541(props.isHidden, matchedBreakpoints)) styleProps.hidden = true;
    return {
        styleProps: styleProps
    };
}
function $380ed8f3903c3931$export$46b6c81d11d2c30a(value) {
    return value;
}
function $380ed8f3903c3931$export$52dbfdbe1b2c3541(prop, matchedBreakpoints) {
    if (prop && typeof prop === "object" && !Array.isArray(prop)) {
        for(let i = 0; i < matchedBreakpoints.length; i++){
            let breakpoint = matchedBreakpoints[i];
            if (prop[breakpoint] != null) return prop[breakpoint];
        }
        return prop.base;
    }
    return prop;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

let $59d09bcc83651bf9$var$SlotContext = /*#__PURE__*/ (0, $5lsDl$react).createContext(null);
function $59d09bcc83651bf9$export$1e5c9e6e4e15efe3(props, defaultSlot) {
    let slot = props.slot || defaultSlot;
    let { [slot]: slotProps = {} } = (0, $5lsDl$useContext)($59d09bcc83651bf9$var$SlotContext) || {};
    return (0, $5lsDl$mergeProps)(props, (0, $5lsDl$mergeProps)(slotProps, {
        id: props.id
    }));
}
function $59d09bcc83651bf9$export$365cf34cda9978e2(cssModule) {
    return Object.keys(cssModule).reduce((acc, slot)=>{
        acc[slot] = {
            UNSAFE_className: cssModule[slot]
        };
        return acc;
    }, {});
}
function $59d09bcc83651bf9$export$8107b24b91795686(props) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    let parentSlots = (0, $5lsDl$useContext)($59d09bcc83651bf9$var$SlotContext) || {};
    let { slots: slots = {}, children: children } = props;
    // Merge props for each slot from parent context and props
    let value = (0, $5lsDl$useMemo)(()=>Object.keys(parentSlots).concat(Object.keys(slots)).reduce((o, p)=>({
                ...o,
                [p]: (0, $5lsDl$mergeProps)(parentSlots[p] || {}, slots[p] || {})
            }), {}), [
        parentSlots,
        slots
    ]);
    return /*#__PURE__*/ (0, $5lsDl$react).createElement($59d09bcc83651bf9$var$SlotContext.Provider, {
        value: value
    }, children);
}
function $59d09bcc83651bf9$export$ceb145244332b7a2(props) {
    let { children: children, ...otherProps } = props;
    let content = children;
    if ((0, $5lsDl$react).Children.toArray(children).length <= 1) {
        if (typeof children === "function") content = /*#__PURE__*/ (0, $5lsDl$react).cloneElement((0, $5lsDl$react).Children.only(children), otherProps);
    }
    return /*#__PURE__*/ (0, $5lsDl$react).createElement($59d09bcc83651bf9$var$SlotContext.Provider, {
        value: {}
    }, content);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 

function $54cda195bd4173fb$export$e52e2242b6d0f1d4(query, ref) {
    let [hasChild, setHasChild] = (0, $5lsDl$useState)(true);
    (0, $5lsDl$useLayoutEffect)(()=>{
        setHasChild(!!(ref.current && ref.current.querySelector(query)));
    }, [
        setHasChild,
        query,
        ref
    ]);
    return hasChild;
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
const $fdbe26a36ce1c672$var$MOBILE_SCREEN_WIDTH = 700;
function $fdbe26a36ce1c672$export$736bf165441b18c7() {
    let isSSR = (0, $5lsDl$useIsSSR)();
    if (isSSR || typeof window === "undefined") return false;
    return window.screen.width <= $fdbe26a36ce1c672$var$MOBILE_SCREEN_WIDTH;
}






export {$fd933927dbac1f15$export$46d604dce8bf8724 as shouldKeepSpectrumClassNames, $fd933927dbac1f15$export$f9d3bfd10703eb31 as keepSpectrumClassNames, $fd933927dbac1f15$export$ce4ab0c55987d1ff as classNames, $bde65b0159e7c06e$export$a5f5a6912b18861c as getWrappedElement, $3df547e395c4522f$export$32d5543ab307c01 as useMediaQuery, $98e5a8ae0e6415af$export$a5795cc979dfae80 as createDOMRef, $98e5a8ae0e6415af$export$79d69eee6ae4b329 as createFocusableRef, $98e5a8ae0e6415af$export$c2c55ef9111cafd8 as useDOMRef, $98e5a8ae0e6415af$export$96a734597687c040 as useFocusableRef, $98e5a8ae0e6415af$export$c7e28c72a4823176 as unwrapDOMRef, $98e5a8ae0e6415af$export$1d5cc31d9d8df817 as useUnwrapDOMRef, $380ed8f3903c3931$export$fe9c6e915565b4e8 as baseStyleProps, $380ed8f3903c3931$export$e0705d1a55f297c as viewStyleProps, $380ed8f3903c3931$export$abc24f5b99744ea6 as dimensionValue, $380ed8f3903c3931$export$f348bec194f2e6b5 as responsiveDimensionValue, $380ed8f3903c3931$export$f3c39bb9534218d0 as convertStyleProps, $380ed8f3903c3931$export$b8e6fb9d2dff3f41 as useStyleProps, $380ed8f3903c3931$export$46b6c81d11d2c30a as passthroughStyle, $380ed8f3903c3931$export$52dbfdbe1b2c3541 as getResponsiveProp, $59d09bcc83651bf9$export$1e5c9e6e4e15efe3 as useSlotProps, $59d09bcc83651bf9$export$365cf34cda9978e2 as cssModuleToSlots, $59d09bcc83651bf9$export$8107b24b91795686 as SlotProvider, $59d09bcc83651bf9$export$ceb145244332b7a2 as ClearSlots, $54cda195bd4173fb$export$e52e2242b6d0f1d4 as useHasChild, $fdbe26a36ce1c672$export$736bf165441b18c7 as useIsMobileDevice, $857d64dbfd73d664$re_export$useValueEffect as useValueEffect, $1051245f87c5981d$export$8214320346cf5104 as BreakpointProvider, $1051245f87c5981d$export$140ae7baa51cca23 as useMatchedBreakpoints, $1051245f87c5981d$export$199d6754bdf4e1e3 as useBreakpoint, $857d64dbfd73d664$re_export$useResizeObserver as useResizeObserver};
//# sourceMappingURL=module.js.map
